/* eslint-disable no-param-reassign */
const getProgressiveJpgUrl = url => {
  if (url.startsWith('//cdn') || url.includes('/cdn/')) {
    url = `https:${url}`;
  }

  url = new URL(url);
  const params = new URLSearchParams(url.search);

  params.append('format', 'pjpg');
  url.search = params;

  return url.toString();
};

export default getProgressiveJpgUrl;
